module.exports = __webpack_public_path__ + "img/34.2369fcd2.svg";